import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { FormControl } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { BASE_URL } from './BaseUrl';
import InnerHeader from './InnerHeader';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { getRoleData } from "../Store/Role/role-action";
import Cookies from "js-cookie";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const FeesReport = () => {

    const [brand, setBrand] = useState([])
    const [error, setError] = useState({})


    const [value, setValue] = useState({
        fromdate: '',
        todate: '',
    })


    const validateForm = () => {
        let isValid = true
        const newErrors = {}


        if (!value.fromdate) {
            isValid = false;
            newErrors.fromdate = "FromDate is required"
        }
        if (!value.todate) {
            isValid = false;
            newErrors.todate = "ToDate is required"
        }
        setError(newErrors)
        return isValid
    }




    useEffect(() => {
        setError({})
    }, [])

    // Utility function to format date like "23 Jun 2025"
    function formatDate(dateStr) {
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return new Date(dateStr).toLocaleDateString('en-GB', options);
    }


    const handleSubmit = (e) => {
        e.preventDefault()

        if (validateForm()) {
            const data = {
                todate: value.todate,
                fromdate: value.fromdate,
            }


            axios.post(`${BASE_URL}/receiptdetails`, data)
                .then((res) => {
                    const rows = res.data;
                    if (!rows || rows.length === 0) {
                        alert("No data found for selected date range.");
                        return;
                    }

                    // Format title
                    const title = `Datewise Receipt Report : From ${formatDate(value.fromdate)} To ${formatDate(value.todate)}`;

                    // Define the worksheet data as AOA (Array of Arrays)
                    const sheetData = [];

                    // Title row (merged later)
                    sheetData.push([null, null, title]);

                    // Header row
                    sheetData.push([
                        "RNo",
                        "RDate",
                        "Student_name",
                        "Course",
                        "Batch",
                        "Mobile",
                        "Email",
                        "Payment_Type",
                        "Amount"
                    ]);

                    // Data rows
                    rows.forEach((row, index) => {
                        sheetData.push([
                            row.RNo,
                            formatDate(row.RDate),
                            row.Student_name,
                            row.Course,
                            row.Batch,
                            row.Mobile,
                            row.Email,
                            row.Payment_Type,
                            row.Amount
                        ]);
                    });

                    // Create worksheet and workbook
                    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

                    // Merge the title across columns B to I (index 1 to 8)
                    worksheet["!merges"] = [
                        {
                            s: { r: 0, c: 1 }, // start cell
                            e: { r: 0, c: 8 }, // end cell
                        },
                    ];

                    // Optional: Adjust column widths
                    worksheet["!cols"] = [
                        { wch: 6 },   // RNo
                        { wch: 12 },  // RDate
                        { wch: 25 },  // Student_name
                        { wch: 35 },  // Course
                        { wch: 10 },  // Batch
                        { wch: 15 },  // Mobile
                        { wch: 30 },  // Email
                        { wch: 20 },  // Payment_Type
                        { wch: 10 },  // Amount
                    ];

                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Receipt Report");

                    // Export to Excel
                    const excelBuffer = XLSX.write(workbook, {
                        bookType: "xlsx",
                        type: "array",
                    });

                    const dataBlob = new Blob([excelBuffer], {
                        type:
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });

                    saveAs(dataBlob, "ReceiptDetails.xlsx");
                })
                .catch((err) => {
                    console.log(err)
                })
        }


    }
    const handleSubmit2 = (e) => {
        e.preventDefault()

        if (validateForm()) {
            const data = {
                todate: value.todate,
                fromdate: value.fromdate,
            }


            axios.post(`${BASE_URL}/getchequedetails`, data)
                .then((res) => {

                })
                .catch((err) => {
                    console.log(err)
                })
        }


    }


    const onhandleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }


    const roledata = {
        role: Cookies.get(`role`),
        pageid: 57,
    };

    const dispatch = useDispatch();
    const roleaccess = useSelector((state) => state.roleAssign?.roleAssign[0]?.accessid);

    useEffect(() => {
        dispatch(getRoleData(roledata));
    }, []);






    return (
        <div className="container-fluid page-body-wrapper ">
            <InnerHeader />
            <div className="main-panel">

                <div className="content-wrapper">
                    <div className="row">
                        <div className="col-lg-12 grid-margin">
                            <div class="d-flex">

                                <div className='px-2 mx-2'><Link to="/feesreport"><h4>Cheque/PDC and Receipts</h4></Link></div>
                                <div className='px-2 mx-2'><Link to="/feesdetails"><h4>Fees Details</h4></Link></div>
                                <div className='px-2 mx-2'><Link to="/facultypayment"><h4>Faculty Payment Detail Report</h4></Link></div>
                            </div>
                            <div className="card">
                                <div className='container-fluid'>
                                    <div className='row d-flex justify-content-between'>

                                        <div className='col-lg-12'>
                                            <div className='row justify-content-center' >
                                                <div className='p-3' style={{ width: "100%" }}>

                                                    <form class="form-sample py-3" onSubmit={handleSubmit}>
                                                        <div class="row">

                                                            <div class="form-group col-lg-3" style={{ display: 'flex', flexDirection: "column" }}>
                                                                <label for="exampleInputUsername1">From Date<span className="text-danger">*</span></label>
                                                                <DatePicker
                                                                    selected={value.fromdate ? new Date(value.fromdate) : null}
                                                                    onChange={(date) => {
                                                                        const formattedDate = date ? date.toISOString().split('T')[0] : '';
                                                                        onhandleChange({ target: { name: "fromdate", value: formattedDate } });
                                                                    }}
                                                                    className="form-control"
                                                                    id="exampleInputUsername1"
                                                                    dateFormat="yyyy-MM-dd" // ✅ Correct format
                                                                    placeholderText="Select Date"
                                                                />

                                                                {<span className="text-danger"> {error.fromdate} </span>}
                                                            </div>

                                                            <div class="form-group col-lg-3" style={{ display: 'flex', flexDirection: "column" }}>
                                                                <label for="exampleInputUsername1">From To Date<span className="text-danger">*</span></label>
                                                                <DatePicker
                                                                    selected={value.todate ? new Date(value.todate) : null}
                                                                    onChange={(date) => {
                                                                        const formattedDate = date ? date.toISOString().split('T')[0] : '';
                                                                        onhandleChange({ target: { name: "todate", value: formattedDate } });
                                                                    }}
                                                                    className="form-control"
                                                                    id="exampleInputUsername1"
                                                                    dateFormat="yyyy-MM-dd" // ✅ Correct format
                                                                    placeholderText="Select Date"
                                                                />
                                                                {<span className="text-danger"> {error.todate} </span>}
                                                            </div>
                                                            <div className="p-4">
                                                                <button className=' btn btn-primary' onClick={handleSubmit}>Print Recipt Details</button>
                                                            </div>
                                                        </div>



                                                    </form>
                                                    <div className='row p-2 gap-2'>
                                                        <button type="button" className='mr-2 btn btn-primary' onClick={handleSubmit2}>Show</button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default FeesReport